export const SUPPORTED_IMAGE_ACCEPT = '.jpg,.jpeg,.png,.webp,.gif,.tif,.tiff,.avif,image/jpeg,image/png,image/webp,image/gif,image/tiff,image/avif';

export const SUPPORTED_IMAGE_FORMAT_LABEL = 'JPG, PNG, WebP, GIF, TIFF, AVIF';